import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import MetaLoader from '../../ui/Loading';
import EmailSMSForm from '../../forms/EmailSMSForm';
import fetchDux from '../../../state/fetch-dux';

import { bindActionCreators } from 'redux';

import LeftNav from './LeftNav';

class AccountDetails extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.validateLogin();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account',
      'page-template-page-templatesshop-template-my-account-php',
      'page',
      'page-id-246',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account',
      'page-template-page-templatesshop-template-my-account-php',
      'page',
      'page-id-246',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      user,
      postEmailPref,
      loading,
      pageLoading,
      postError,
      postEmailPrefResult
    } = this.props;
    const scrollToTop = () => window.scrollTo(0, 0);

    const {
      ClubMember,
      MailingPrefs,
      secondaryContact,
      smsMarketingTW,
      smsTransactional,
      name_first,
      name_last,
      DOB,
      userId
    } = user || {};
    const { IsActive, ClubName } = ClubMember || {};

    const { twomey } = MailingPrefs || {};

    if (!user) return <div />;

    const handleSubmit = (values) => {
      const payload = { 
        ...values, 
        userId, 
        DOB, 
        brandingId: 2, 
        SMSSubscribe: true, 
        doesAgree: true, 
        source: 'Twomey.com - Account Preferences', 
        firstName: name_first, 
        lastName: name_last,
        discoveryPreferences: [{ listKey: 'IsDiscoveringTwomey', value: true }],
 
      };
      postEmailPref({ payload }, 'Email-SMS-Form');
    };

    return (
      <div id="content" className="site-content">
        <MetaLoader title="Account | Twomey" />
        <MetaTags>
          <title>Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Account | Twomey" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://twomey.com/account" />
        </MetaTags>
        <div id="primary" className="content-area">

          <main id="main" className="site-main account-page nohero">
            <div className="container">
              <div className="row">

                <LeftNav />

                <div className="col-products">
                  <h1 className="smaller">Account Details</h1>

                  {pageLoading && <Loading fullPage scrollToTop />}
                  {!pageLoading &&
                    <div className="row">
                      <div className="col-md-4 customer-detail">
                        <h3 className="larger">Member Information</h3>
                        <p className="account-info-block">
                          <strong>Name:</strong>
                          {user.name_first} {user.name_last}
                        </p>
                        <p className="account-info-block">
                          <strong>Email Address:</strong>
                          {user.email}
                          <p>{`Receiving email news and offers: ${twomey ? 'Yes' : 'No'}`}</p>

                        </p>
                        <p className="account-info-block">
                          <strong>Mobile Phone:</strong>
                          {user.mobilePhone}
                          <p style={{ marginBottom: '0px' }}>{`Receiving text news and offers: ${user.smsMarketingTW ? 'Yes' : 'No'}`}</p>
                          <p >{`Receiving text order updates: ${user.smsTransactional ? 'Yes' : 'No'}`}</p>

                        </p>
                        <p className="account-info-block">
                          <strong>Address:</strong>
                          <Link to="/account/edit-profile/address-book">
                            <em>Manage address book</em>
                          </Link>
                        </p>
                        <div className="account-info-block">
                          <Link
                            to="/account/edit-profile"
                            className="btn btn-primary btn-block"
                          >
                            Edit Profile
                          </Link>
                        </div>
                      </div>
                      <div className="col-md-4 customer-detail">
                        <h3 className="larger">Secondary Contact</h3>

                        {!secondaryContact &&
                          <div className="account-info-block">
                            <Link
                              to="/account/edit-profile/secondary-contact"
                              className="btn btn-inverse"
                              style={{ fontSize: "0.6rem", position: "relative", top: "-275px" }}
                            >
                              Add Secondary Contact
                            </Link>
                          </div>}

                        {secondaryContact &&
                          <>
                            <p className="secondary-info">
                              <strong>Name:</strong>
                              {secondaryContact.name_first} {secondaryContact.name_last}
                            </p>
                            <p className="secondary-info">
                              <strong>Email Address:</strong>
                              {secondaryContact.email}
                            </p>
                            <p className="secondary-info">
                              <strong>Relationship:</strong>
                              {secondaryContact.relationship}
                            </p>
                            <p className="secondary-info">
                              <strong>Phone:</strong>
                              {secondaryContact.phone}
                            </p>
                            <p className="secondary-info">
                              <strong>Preferences:</strong>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled='true'
                                />
                                <label >
                                  Order Notifications
                                </label>
                              </div>
                            </p>

                            <div className="account-info-block">
                              <Link
                                to="/account/edit-profile/secondary-contact"
                                className="btn btn-primary btn-block"

                              >
                                Edit Secondary Contact
                              </Link>
                            </div>
                          </>


                        }


                      </div>


                      <div className="col-md-4">
                        <h3>Club Level</h3>
                        {!IsActive &&
                          <div>
                            <p className="account-info-block">
                              It looks like you haven't joined a club.
                              Join a club to receive percentage off of wines and exclusive invites to our best events.
                            </p>
                            <p className="account-info-block">
                              <a
                                href="/wine-club/"
                                className="btn btn-primary btn-block"
                              >
                                Join a Club
                              </a>
                            </p>
                          </div>}
                        {IsActive && <div>{ClubName} Club</div>}
                      </div>
                      {!twomey && !postEmailPrefResult &&
                        <div className="col-md-12">
                          <h3 className="larger">
                            Be the First to Know
                          </h3>
                          <p>Sign up to get notified about new releases, winery exclusives, and curated experiences.</p>

                          <div className="account-info-block">
                            <EmailSMSForm
                              onSubmit={handleSubmit}
                              smsMarketingTW={smsMarketingTW}
                              smsTransactional={smsTransactional}
                              postError={postError}
                              loading={loading}
                            />

                            {loading &&
                              <Loading
                                inline
                                message={
                                  <span
                                    style={{
                                      marginLeft: '10px',
                                      color: '#979797'
                                    }}
                                  >
                                    Applying changes...
                                  </span>
                                }
                              />}
                          </div>
                        </div>}
                    </div>}
                  {postEmailPrefResult &&
                    <div>
                      <h3>Thank You!</h3>
                      <p>
                        We are excited you joined our mailing list.
                        You will now be able to hear more about our upcoming events and promotional offers!
                      </p>
                    </div>
                  }
                </div>
              </div>
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    result: user,
    inProgress: pageLoading
  } = state.postLogin.toJS();

  const {
    inProgress: loading,
    error: postError,
    result: postEmailPrefResult
  } = state.postEmailPref.toJS();

  return {
    user,
    loading,
    pageLoading,
    postError,
    postEmailPrefResult
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      validateLogin: fetchDux.validateLogin.createAction,
      postEmailPref: fetchDux.postEmailPref.createAction,
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(AccountDetails);
